
import { useEffect } from 'react';

import { InterimStates } from "../../components/Protected/InterimStates";

import { useQuery, gql } from '@apollo/client';

interface IProps {
    triggerRefetch?: boolean,
    personId: number,
    courseId: number,
}

const PERSON_COURSE_ATTENDANCE = gql`
    query Query($userId: Int!, $courseId: Int!) {
        userCourseAttendance(userId: $userId, courseId: $courseId)
    }
`;

const PersonCourseAttendance = ({
    personId,
    triggerRefetch,
    courseId,
}: IProps) => {
    const { loading, error, data, refetch } = useQuery(PERSON_COURSE_ATTENDANCE, {
        variables: {
            userId: personId,
            courseId: courseId,
        }
    });

    useEffect(() => {
        refetch();
      }, [triggerRefetch, refetch]);


    if (loading || error) {
        return <InterimStates loading={loading} error={error} label='tags' />
    }

    return (
        <>
        {Math.round(data.userCourseAttendance * 10000) / 100}%
        </>
    )
}

export { PersonCourseAttendance }
